export default __webpack_public_path__ + "static/media/ryzen7.a0148837.png";